import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  MergedScheduledPayment,
  TransactionStatusStepper,
  TransactionStatus,
  TransactionHistoryItem,
  formattedCurrency,
  withStyles,
} from 'vopay';
import { Title } from 'UI';
import styles from './ScheduledTransactionCard.module.scss';

const cn = withStyles(styles);

type ScheduledTransactionCardProps = {
  transaction: MergedScheduledPayment;
};

const SCHEDULE_STATUS_TO_TRANSACTION_STATUS: Record<MergedScheduledPayment['Status'], TransactionStatus> = {
  'in progress': TransactionStatus.IN_PROGRESS,
  cancelled: TransactionStatus.CANCELLED,
  completed: TransactionStatus.COMPLETE,
  'pending approval': TransactionStatus.PENDING_APPROVAL,
};

const ScheduledTransactionCard: FC<ScheduledTransactionCardProps> = ({ transaction }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'ScheduledTransactions.Details.Card' });

  // DateAdded is left blank — there's no per-status timestamp for a schedule.
  const transactionHistory: TransactionHistoryItem[] = [
    {
      Status: SCHEDULE_STATUS_TO_TRANSACTION_STATUS[transaction.Status] ?? TransactionStatus.BLANK,
      DateAdded: '',
    },
  ];

  return (
    <Card className={cn('card')}>
      <Box jc="sb" gapSize="24px">
        <Box flx="col" gapSize="24px">
          <Title level="2">{transaction.FullName}</Title>

          <Box flx="col" gapSize="32px" padding="0 0 0 6px">
            <Box flx="col" gapSize="5px">
              <Title level="5" emphasized={false} className={cn('grey')}>
                {t('scheduledAmountPerTransaction', { defaultValue: 'Scheduled Amount per Transaction' })}
              </Title>
              <Title level="4">
                {transaction.Currency} {formattedCurrency(transaction.Amount)}
              </Title>
            </Box>

            <div className={cn('idContainer')}>
              <Box flx="col" gapSize="6px">
                <div className={cn('grey')}>{t('scheduleID', { defaultValue: 'Schedule ID' })}</div>
                <div className={cn('fontWeight500')}>{transaction.ID}</div>
              </Box>
            </div>
          </Box>
        </Box>

        <TransactionStatusStepper transactionHistory={transactionHistory} />
      </Box>
    </Card>
  );
};

export default ScheduledTransactionCard;
